<template>
	<svg id="icon_mdi-check-circle" data-name="icon/mdi-check-circle" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
		<path id="Path_429" data-name="Path 429" d="M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2ZM10,17,5,12l1.41-1.41L10,14.17l7.59-7.59L19,8Z" transform="translate(-2 -2)" fill="#fff"/>
	</svg>
</template>

<script>
	export default {
		name: 'tune'
	}
</script>